import { render, staticRenderFns } from "./ArticleStructuredData.vue?vue&type=template&id=04abf501"
import script from "./ArticleStructuredData.vue?vue&type=script&lang=js"
export * from "./ArticleStructuredData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports